import Keycloak, {type KeycloakConfig} from 'keycloak-js';
import { ELocalStorageItems } from './enums/ELocalStorageItems';

const kcConfigString = localStorage.getItem(ELocalStorageItems.KC_CONFIG);
let kcConfig: KeycloakConfig = {clientId: '', realm: '', url: ''};

try {
  kcConfig = JSON.parse(kcConfigString ?? '{}');
} catch (e) {
  // Do something
}

const keycloakObject = new Keycloak(kcConfig);

export default keycloakObject;
